import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dbHeaderHost]'
})
export class HeaderHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
